/**
 * Created by Daniel on 7/10/2017.
 */

var activeSection = require('./../libs/jquery-activeSection');

const LazyPageSection = {
    lastScroll: 0,
    debounce: 1000,
    loadCount: 0,

	load: function (container) {
		const $container = $(container);
//		console.log("Lazy load called", {container: container});
		var dataLocation = container.dataset.location;
		if (!dataLocation) {
			container = $container.parent()[0];
			dataLocation = container.dataset.location;
			if (!dataLocation) { return; }
		}
		if (!$container.hasClass('not-loaded')) return;
		if ($container.hasClass('load-pending')) return;
		LazyPageSection.loadCount++;
		if (!container.id) container.id = "ajax__container" + LazyPageSection.loadCount;
		var id = container.id;
//		console.log("loading " + id);
		$container.addClass('load-pending');
		Linksoft.Web.LoadByAjax(id, {
			url: dataLocation,
			cache: container.dataset.cache || false,
			":background": true,
			successHandlerPrepare: ($container.data("prepare") ? function () { eval($container.data("prepare")) } : null),
			successHandler: function () {
				$container.removeClass('not-loaded');
				$container.removeClass('load-pending');
				LazyPageSection.handler();
				if ($container.data("finish")) { eval($container.data("finish")) }
			},
			errorHandler: function () {
				$container.removeClass('not-loaded');
				$container.removeClass('load-pending');
			}
		});
	},

    loadContent: function (loadInto) {
        if (!loadInto.length) return;
		this.currentScroll = $(window).scrollTop();
//		console.log("loadContent: currentScroll", this.currentScroll);

        for(let i = 0; i < loadInto.length; i++) {
            const targetOffset = loadInto[i].offsetTop;
            const windowHeight = window.innerHeight;
            const toBeLoaded = this.currentScroll > (targetOffset - 2*windowHeight);
//          console.log(this.currentScroll + ' > ' + (targetOffset - windowHeight), loadInto[i]);
			if (toBeLoaded) {
				LazyPageSection.load(loadInto[i]);
            }
		}
	},
	handler: function () {
//		console.log("Lazy handler");
		if (LazyPageSection.lastScroll + LazyPageSection.debounce > Date.now()) return;
		LazyPageSection.lastScroll = Date.now();
		const ajaxContainers = document.querySelectorAll('.ajax__container.not-loaded');
		if (!ajaxContainers.length) return;

//		console.log("Lazy load content");
		LazyPageSection.loadContent(ajaxContainers)
	},
	init: function () {
//		console.log("Lazy init started");

		document.addEventListener('scroll', LazyPageSection.handler);
		document.addEventListener('resize', LazyPageSection.handler);
		document.addEventListener('hashchange', LazyPageSection.handler);
		LazyPageSection.timerId = window.setInterval(LazyPageSection.handler, 1000);
		LazyPageSection.handler();

//		console.log("Lazy init done");
    }
};

$(LazyPageSection.init);
window.LazyPageSection = LazyPageSection;
